import { IAction, IUser } from '../../schemas';
import { GET_COORDINATOR_LIST } from '../constant';

const initState: IUser[] = [];

export default function coordinatorReducer(
	preState = initState,
	action: IAction<any>
): IUser[] {
	const { type, data } = action;
	switch (type) {
		case GET_COORDINATOR_LIST:
			return [...data];
		default:
			return preState;
	}
}
